'use client';

import React, { useEffect, useState } from 'react';
import AppButton from '@/src/app/components/Button/AppButton';
import Cookies from 'js-cookie';
import { defaultLocale, languageCookieName } from '@/src/lib/dictionary/settings';
import { Dictionary } from '@/src/lib/dictionary/types';
import { getDictionary } from '@/src/lib/dictionary/dictionaries';
import { handleException } from '@/src/lib/core/exception/handle-exception';
import { IconName } from '@/src/app/components/Icon/types';
import LogoClaim from '@/src/app/components/Logo/LogoClaim.tsx';
import { TENANT } from '@/src/lib/core/config.ts';

function Error({ error }: { error: Error & { digest?: string } }) {
  const lang = Cookies.get(languageCookieName) || defaultLocale;
  const country = TENANT.toLowerCase();
  const [dict, setDict] = useState<Dictionary | null>(null);

  useEffect(() => {
    (async () => {
      if (dict) return;
      setDict(await getDictionary(lang));
    })();

    if (error) {
      handleException(error);
    }
  }, [error, dict, lang]);

  if (!dict) return null;

  return (
    <body className="h-screen font-sans">
      <main className="relative isolate min-h-full text-black bg-primary">
        <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
          <div className="flex flex-row-reverse">
            <LogoClaim lang={lang} country={country} />
          </div>
          <h1 className="mt-16 display-title-5xl">{dict.opsPage.title}</h1>
          <p className="mt-4 text-base/70 sm:mt-6">{dict.opsPage.description}</p>
          <div className="mt-10 flex gap-4 justify-center">
            <AppButton onClick={() => (window.location.href = '/')} outline priority icon={IconName.HOME}>
              {dict.general.backToHomeBtn}
            </AppButton>
            <AppButton
              onClick={() => window.location.reload()}
              priority
              className="text-sm font-semibold leading-7"
              icon={IconName.REFRESH}
            >
              {dict.opsPage.resetBtn}
            </AppButton>
          </div>
        </div>
      </main>
    </body>
  );
}

export default Error;
